export default __webpack_public_path__ + "static/media/CloseEyesRingRing.fcc9ff4d.png";